import * as React from "react";
import { cn } from "@/utils/utils";

interface Props {
  className?: string;
  dividerYPadding?: "0" | "4" | "8" | "16";
}

// Tailwind can't detect arbitrary-value classes built from a template
// literal (e.g. `py-[${x}px]`) — the full literal class name has to appear
// somewhere in source for the JIT scanner to pick it up, so the padding
// options are spelled out here instead of interpolated.
//
// Margin, not padding: `border-t` draws its line at the very top of the
// box, so padding (inside the border) only ever adds space below the
// line. Margin sits outside the border on both sides, giving the line
// even spacing above and below it.
const Y_PADDING_CLASSES: Record<NonNullable<Props["dividerYPadding"]>, string> = {
  "0": "my-0",
  "4": "my-1",
  "8": "my-2",
  "16": "my-4"
};

const Divider: React.FC<Props> = ({ className, dividerYPadding = "8" }) => {
  return (
    <div
      className={cn(
        "border-t border-border-border1",
        Y_PADDING_CLASSES[dividerYPadding],
        className
      )}
    />
  );
};
Divider.displayName = "Divider";

export { Divider };
